import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {
   /**
   * @author kailash_dev
   * @param LanguagesComponent
   * Add new language and edit.
   */
  addOrEditLanguage: string;
  languages = [];
  title = 'modal2';
  formGroup;
  deletePopupUiData;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private xlsx: XlsxService,
    // public toastService: ToastService
    public toast: ToastClientService
  ) {}

  ngOnInit() {
    this.getAllLanguages();
  }

  getAllLanguages() {
    this.apiService.getHeaders(this.apiConfig.configGetLanguages)
      .subscribe((res: any) => {
        this.languages = res.body.data;
      }, err => {
        console.log(err);
      })
  }

  addlanguage(targetModal) {
    this.addOrEditLanguage = 'add'
    this.formGroup = this.fb.group({
      lang_name: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
      short_name: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
    });

    this.showlanguageModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editlanguage(targetModal, lang){
    console.log(lang);
    this.addOrEditLanguage = 'edit'
    this.formGroup = this.fb.group({
      lang_name: new FormControl(lang.lang_name, [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
      short_name:new FormControl(lang.short_name, [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
      id: lang.id,
      status:lang.status
    });

    this.showlanguageModal(targetModal);
  }

  deletelanguage(targetModal, lang){
    this.addOrEditLanguage = 'delete'
    this.deletePopupUiData = lang.lang_name;

    this.formGroup = this.fb.group({
      id: lang.id,
    });

    this.showlanguageModal(targetModal);
  }

  showlanguageModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }


  submitted = false;

  onSubmitlanguage(formData) {

    this.submitted = true;

    if(this.formGroup.invalid){
      return
    }

    let apiUrl;
    if(this.addOrEditLanguage == 'add'){
      apiUrl = this.apiConfig.configAddLanguage
      let shortName =  formData.lang_name;
      console.log(shortName)
    } else if(this.addOrEditLanguage == 'edit' || this.addOrEditLanguage == 'delete'){
      apiUrl = this.apiConfig.configEditLanguage + '?id=' + formData.id;
      this.editLanguage(apiUrl,formData);
      return;
    } else if(this.addOrEditLanguage == 'delete'){
      apiUrl = this.apiConfig.configDeleteLanguage
    }
    console.log('API:', apiUrl, 'FD:', formData);
      this.apiService.post(apiUrl, formData)
      .subscribe((res:any)=>{
        this.toast.Success(res.data.message);
        this.languageActionSuccess(formData);
      },err=>{
        console.log('err', err);
      })

  }

  editLanguage(url,formData){
    this.apiService.put(url, formData)
      .subscribe((res:any)=>{
        console.log('successfully Added', res);
        this.languageActionSuccess(formData);
      },err=>{
        console.log('err', err);
      })
  }

  languageActionSuccess(data){
    this.modalService.dismissAll();
    this.getAllLanguages();
  }
  uploadXlsx(eve){
    this.xlsx.uploadXlsx(eve).then(res => {
      this.xlsxView(res);
    });
  }
  xlsxView(data){
    let modalRef =this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true,
      windowClass : "myCustomModalClass"
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then((result) => {
      console.log(result);
    }, (reason) => {
    });
  }
}
